import { connect } from 'react-redux';
import SaunaMeasurementsPage from '../components/SaunaMeasurementsPage';
import { skipMeasurements, measurementsUpdated, skipStoveAndDoorPositioning, enableStoveAndDoorPositioning, measurementsGiven } from '../actions';
import measurements from '../reducers/measurements';
const mapStateToProps = (state, ownProps) => ({
    nextPage: ownProps.nextPage,
    allowSkipMeasurements: state.clientConfiguration.allowSkipMeasurements
});

const mapDispatchToProps = (dispatch, ownProps) => ({ 
  skipMeasurements:()=>{
    dispatch(skipMeasurements());
     ownProps.nextPage();
    },
    onMeasurementsSubmit: (measurements) => {
        dispatch(measurementsUpdated(parseIntegers(measurements)))
        if (measurementsDefined(measurements)) {
            dispatch(enableStoveAndDoorPositioning());
            dispatch(measurementsGiven());
            ownProps.nextPage();
        }
        else { 
            dispatch(skipStoveAndDoorPositioning());
            ownProps.nextPage();
    }
    }
  
});

const SaunaMeasurementsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SaunaMeasurementsPage);

export default SaunaMeasurementsContainer;


let parseIntegers = (measurements) => {
    let result = {};
    for (let key in measurements) {
        if (key != "floorImage" && key!="comment") result[key] = parseInt(measurements[key])
        else result[key] = measurements[key];
    }
    return result;

}

let measurementsDefined = (measurements) => {
    return measurements.doorWallWidth > 0 && measurements.depth > 0 && measurements.height > 0 && measurements.doorWidth > 0
}